import { View, ViewMeta } from '@yleisradio/areena-types';
import { useUILanguage } from 'hooks/useUILanguage';
import React from 'react';
import { SchemaOrgNode } from 'services/schema-org/types';
import { Query } from 'types/query';
import { AppBanner } from './AppBanner';
import { GenericMetadata } from './GenericMetadata';
import { SchemaOrg } from './SchemaOrg';
import { SocialMediaTags } from './SocialMediaTags';
import { useTitle } from './useTitle';
import { getRssFeedUrl } from 'utils/url';

export type MetaImageAspectRatio = '16:9' | '1:1';

interface Props {
  path: string;
  query: Query;
  schemaOrgNode: SchemaOrgNode | null;
  view: View;
  viewMeta: ViewMeta;
  guideDate: string | null;
  isTodaysGuide: boolean;
  metaImageAspectRatio: MetaImageAspectRatio;
  slugs: Record<string, string> | null;
}

export const Metadata: React.FunctionComponent<Props> = ({
  path,
  query,
  schemaOrgNode,
  view,
  viewMeta,
  guideDate,
  isTodaysGuide,
  metaImageAspectRatio,
  slugs,
}) => {
  const { description, image, item, ogType, robots, series } = viewMeta;

  const { duration, releaseDate } = item || {};

  const language = useUILanguage();
  const title = useTitle({ view, viewMeta, guideDate, isTodaysGuide });
  const siteName = language === 'sv' ? 'Yle Arenan' : 'Yle Areena';
  const rssFeedUrl = item ? getRssFeedUrl(item, language) : null;

  return (
    <>
      <GenericMetadata
        description={description}
        path={path}
        query={query}
        robots={robots}
        rssFeedUrl={rssFeedUrl}
        siteName={siteName}
        title={title}
        slugs={slugs}
      />
      <AppBanner path={path} />
      <SchemaOrg node={schemaOrgNode} />
      <SocialMediaTags
        description={description}
        duration={duration}
        image={image}
        ogType={ogType}
        path={path}
        query={query}
        releaseDate={releaseDate}
        series={series}
        siteName={siteName}
        title={title}
        metaImageAspectRatio={metaImageAspectRatio}
      />
    </>
  );
};
